import React from 'react'


import Logo from '../media/logoempresa.png'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom';

export const HeaderNoLog = () => {
    const Navigate = useNavigate();

    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12 }}
            sx={{
                justifyContent: "center",
                alignItems: "center",
            }}
            // className='fondo-azul load header'
            style={{ padding: '1em' }}
        >
            <Grid
                container
                direction="row"
                size={{ xs: 12 }}
                sx={{
                    justifyContent: "center",
                    alignItems: "center",
                }}
                style={{ gap: '0.5em' }}
            >
                <Grid
                    container
                    direction="column"
                    size={{ xs: 12 }}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Grid
                        container
                        direction="column"
                        size={{ xs: 3, sm: 4, md: 3, xl: 0.5 }}
                        sx={{
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        className='no-select pointer'
                        onClick={() => Navigate("/")}
                    >
                        <img src={Logo} alt="" style={{ maxWidth: '100%' }} />
                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )
}
